import { Event } from "../shared/lib/graphql/flowTypes";

export const getEventTitle = (event: Event): string => {
  const obligation = event.obligation;
  const activity = event.activity;
  const title = (obligation || activity || { title: { en: "", es: "" } })
    .title as { [key: string]: string };
  return title["en"];
};
